/**
 * ShareButton Component
 *
 * Button to open share dialog
 * Placed in dashboard header
 */

import { useState } from "react"
import { shellControlClass } from "@/components/layout/shellControl";
import { ShareDialog } from "./ShareDialog";
import { HugeiconsIcon } from "@hugeicons/react"
import { Link01Icon } from "@hugeicons/core-free-icons"

export function ShareButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={shellControlClass}
        aria-label="Share"
      >
        <HugeiconsIcon icon={Link01Icon} size={13} />
        <span className="hidden sm:inline">Share</span>
      </button>

      <ShareDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
